import { render, staticRenderFns } from "./BlackGoldQuestionDetailModal.vue?vue&type=template&id=582f424b&"
import script from "./BlackGoldQuestionDetailModal.vue?vue&type=script&lang=js&"
export * from "./BlackGoldQuestionDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports